import React from 'react';
import helper from 'components/utils/helper';
import { SearchInput, SearchFormStyled, SearchIcon} from "./searchInput.style"

const SearchForm = () => {
    let {language} = helper.getUrlLocale();
    
    return ( 
        <SearchFormStyled action={`${language !== 'en' ? '/' + language : ''}/search/`} method="get">
            <SearchInput type="text" name="q" />
            <SearchIcon type="submit"/>
        </SearchFormStyled>
    );
};

export default SearchForm;